import type {
    IClassification, IClassificationNoSub, IClearTable2EditDataAction,
    IDataType, IGetKeyRoadMapAction, IGetProjectInfoAction, IGetTechClassificationAction, IKeyRoadMap,
    IKeyRoadMapQuery, IPagination, IProjectInfo, IProjectInfoQuery, ISetKeyRoadMapAction, ISetKeyRoadMapPaginationAction,
    ISetProjectInfoAction, ISetDicClassListAction, ISetTechClassificationAction, ITable1EditDataAction, ITable2EditDataAction,
    IWorkgroup, IWorkgroupClassAction, IWorkgroupClassAddAction, IWorkgroupClassSetAction, IClassOptionResData,
    IGetProjectInfoByIdAction, ISetClassficationPaginationAction, ISetProjectInfoPaginationAction, IClearStoreAction
} from '@/store/models/tableEdit.model'
import { TableDataCons } from '@/store/constant/table.constant'

export const setEditData = (payload: IDataType): ITable1EditDataAction => ({
    type: TableDataCons.SETEDITDATA,
    payload
})

export const setEdit2Data = (payload: IProjectInfo): ITable2EditDataAction => ({
    type: TableDataCons.SETEDITDATA2,
    payload
})
export const clearEdit2Data = (): IClearTable2EditDataAction => ({
    type: TableDataCons.CLEAREDITDATA2
})

export const getWorkgroup = (): IWorkgroupClassAction => ({
    type: TableDataCons.GETWORKGROUPCLASS
})
export const addWorkgroup = (groupName: string, ptnHeader: string): IWorkgroupClassAddAction => ({
    type: TableDataCons.ADDWORKGROUPCLASS,
    payload: {
        groupName,
        ptnHeader
    }
})

export const setWorkgroup = (payload: IWorkgroup[]): IWorkgroupClassSetAction => ({
    type: TableDataCons.SETWORKGROUPCLASS,
    payload
})

export const getKeyRoadMap = (payload: IKeyRoadMapQuery | number): IGetKeyRoadMapAction => ({
    type: TableDataCons.GETKEYROADMAP,
    payload
})
export const setKeyRoadMap = (payload: IKeyRoadMap[]): ISetKeyRoadMapAction => ({
    type: TableDataCons.SETKEYROADMAP,
    payload
})
export const setKeyRoadMapPagination = (payload: IPagination): ISetKeyRoadMapPaginationAction => ({
    type: TableDataCons.SETKEYROADMAPPAGINATION,
    payload
})
export const setClassificationPagination = (payload: IPagination): ISetClassficationPaginationAction => ({
    type: TableDataCons.SETCLASSIFICATIONPAGINATION,
    payload
})
export const setProjectInfoPagination = (payload: IPagination): ISetProjectInfoPaginationAction => ({
    type: TableDataCons.SETPROJECTINFOPAGINATION,
    payload
})

export const getTechClassification = (payload: IKeyRoadMapQuery): IGetTechClassificationAction => ({
    type: TableDataCons.GETTECHCLASSIFICATION,
    payload
})
export const setTechClassification = (payload: IClassification[] | IClassificationNoSub[]): ISetTechClassificationAction => ({
    type: TableDataCons.SETTECHCLASSIFICATION,
    payload
})

export const getProjectInfoList = (payload: IProjectInfoQuery): IGetProjectInfoAction => ({
    type: TableDataCons.GETPROJECTINFO,
    payload: {
        ...payload,
        pageNo: payload?.pageNo,
        pageSize: payload?.pageSize,
    }
})
export const getProjectInfoById = (payload: {projectInfoId: number}): IGetProjectInfoByIdAction => ({
    type: TableDataCons.GETPROJECTINFOBYID,
    payload
})
export const setProjectInfoList = (payload: IProjectInfo[]): ISetProjectInfoAction => ({
    type: TableDataCons.SETPROJECTINFO,
    payload
})

export const setDicClassList = (payload: {
    [propertys: string]: IClassOptionResData[]
}): ISetDicClassListAction => ({
    type: TableDataCons.SETDICCLASSLIST,
    payload
})

export const clearStore = (): IClearStoreAction => ({
    type: TableDataCons.CLEARSTORE
})

